import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useClientTabRedesign = (): boolean => useSelector(selectAuthData)?.commonData?.clientTabRedesignEnabled === true

export default useClientTabRedesign
